module.exports = __webpack_public_path__ + "img/HZGB03-03.15066bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB03-03.jpg
// module id = dBQx
// module chunks = 0